@for (announcement of localizedAnnouncements(); track announcement.id; let first = $first) {
  <div
    class="d-flex align-items-center justify-content-between gap-3 bg-primary text-white px-3 py-2 border-white border-opacity-50"
    [class.border-top]="!first"
    role="alert"
  >
    <span>{{ announcement.message }}</span>

    <button
      type="button"
      class="btn-close btn-close-white flex-shrink-0 me-n2"
      aria-label="Close"
      (click)="onClose(announcement.id)"
    ></button>
  </div>
}
